// Creation forms may immediately request an upgrade again, so return to the list.
export function getPricingClosePath(from) {
  if (typeof from !== "string" || !from.startsWith("/") || from.startsWith("//") || from.includes("\\")) return "/workspaces";
  const pathname = from.split(/[?#]/)[0].replace(/\/$/, "");
  if (/^\/biz\/create\/(event|service|class)$/.test(pathname)) return "/biz/bookingtypes?v=booking";
  if (pathname.startsWith("/biz/") && pathname !== "/biz/pricing") return from;
  return "/workspaces";
}
